export const name: string = 'TreeList';
export const group = 'Charting';
export const moduleName: string = 'pdc-widget-treelist';
export const icon: string = 'list-alt';
export const namespace: string = 'business-intelligence';
export const themeId: string = 'widget-treelist'; //VR: Theme ID (to SELECT and EXPAND it in Theme dialog)

export const DEFAULT_GROUP_COLOR = '#cbf5fe';

export const SHOW_SERVICE_COLUMNS: boolean = false;

export const isTree_HIDDEN_IN_CONFIG = true; //LL: 25.11.24 (or isTreeHideInConfig)
//   Leo insists on removing isTree option in Config - for lowest level (when data is tree itself - AT WorkItems),
//   thinks it is too complicated.
//   Suggested for me to do it in some other way - see how it is made for Grouping Nodes. Problem is - where to do it ?
//   Now his TreeList use-cases don't need isTree
//  Note: It is not about Grouping Nodes !!! They are customized in TreeOptions. Parent Attribute is defined there !

export const LOAD_ON_DEMAND_ON_EACH_LEVEL = true; //LL: 26.11.24
//  Discussed with Leo.
//  Because the 2nd Group may be very large (1.Orgunit 2.Person), better create each Level onExpand.
//  Also, Groups may be not independent, so Filter can be applied to diminish the 2nd Group
//
//LL: If lower Group is dependent, maybe specify the Link Attribute ???
//    It was done in my 1st implementation - for each Group to each Group
//    If link is null, the 2nd Group is loaded only once. And applied to every higher Node

export const ALLOW_GROUP_BY_ANY_ATTRIBUTE = true; //LL: 18.03.25

export const themeFields = {
    //LL: TL  these are copies of Grid
    rowHighligtingColor: 'widget-grid-row-highlighting-color',
    showCollapseExpandButton: 'widget-grid-show-collapse-expand-button',
    showCollapseGroupingsByDefault: 'widget-grid-show-collapse-groupings-by-default',
    allowGrouping: 'widget-grid-allow-grouping',
    showFilterRow: 'widget-treelist-show-filter-row', // 'widget-grid-show-filter-row',
    showToolbar: 'widget-treelist-show-grid-toolbar', // 'widget-grid-show-grid-toolbar',
    useRowMode: 'widget-grid-use-row-mode',

    //LL: 17.03.24  TL
    edit_allowEditing: 'widget-treelist-editing-allow', //LL don't rem
    //edit_editingMode: 'widget-treelist-editing-editingMode', //LL: 13.05.24: TL not used for now, don't rem
    //edit_transactionMode: 'widget-treelist-editing-transaction-mode', //LL: 13.05.24: TL not used for now, don't rem

    //edit_allowInserting: 'widget-treelist-editing-allow-inserting', //LL: 13.05.24: TL not used for now, don't rem
    edit_DataEditDialogID_Inserting: 'widget-treelist-editing-data-edit-dialog-id-inserting', // by EU
    //edit_allowUpdating: 'widget-treelist-editing-allow-updating', //LL: 13.05.24: TL not used for now, don't rem
    edit_DataEditDialogID_Updating: 'widget-treelist-editing-data-edit-dialog-id-updating', // by EU
    edit_allowDeleting: 'widget-treelist-editing-allow-deleting',
    edit_buttonsPosition: 'widget-treelist-editing-buttonsPosition',

    multiRowOperations: 'widget-treelist-multiRowOperations', //LL: 15.11.24
    useApplyButton: 'widget-treelist-useApplyButton', //LL: 14.03.25

    nodes_removeEmptyGroupNodes: 'widget-treelist-nodes-removeEmptyGroupNodes', //LL: 20.03.24  TL
    require_dataCount_role: 'widget-treelist-require-dataCount-role', //LL: 22.03.24  TL
    nodes_hideLowLevelWithoutParent: 'widget-treelist-nodes-hide-low-level-without-parent', //LL: 10.12.24  TL

    nodes_groupRowsColoring: 'widget-treelist-nodes-groupRowsColoring', //LL: 27.03.24  TL
    groupingOrder_show_inToolbar: 'widget-treelist-groupingOrder-show-inToolbar', //LL: 06.05.24  TL
    nodes_groupRows_separatorInUnion: 'widget-treelist-nodes-groupRows-separatorInUnion', //LL: 23.12.24 TL
    config_highlight_tree_columns: 'widget-treelist-config-highlight-tree-columns' //LL: 31.03.25 TL
};
